module.exports = __webpack_public_path__ + "img/gift.edf8b2a9.svg";